import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { TokenComponent } from './auth/token/token.component';
import { DataCleanerComponent } from './data-cleaner/data-cleaner.component';
import { DataRulesHistoryComponent } from './data-rules/data-rules-history/data-rules-history.component';
import { DataRulesSwitchComponent } from './data-rules/data-rules-switch.component';
import { DataToolsSettingsComponent } from './datatools-settings/data-tools-settings.component';
import { EnrichmentCreditHistoryComponent } from './enrichment-settings/enrichment-credit-history/enrichment-credit-history.component';
import { EnrichmentSettingsComponent } from './enrichment-settings/enrichment-settings.component';
import { DuplikitOptionsComponent } from './datatools-settings/duplikit-options/duplikit-options.component';
import { DashboardComponent } from './duplikit/dashboard-component/dashboard.component';
import { DuplikitHistoryComponent } from './duplikit/duplikit-history/duplikit-history.component';
import { ReportComponent } from './duplikit/report/report.component';
import { LandingPageComponent } from './landing-page/landing-page';
import { DataToolsApps, DataToolsAppsTitles } from './shared/DataToolsApps';
import { UsersManagementComponent } from './users-management/users-management.component';

// TODO: look into path location strategy
export const routes: Routes = [

  // Landing Page
  {path: '', component: LandingPageComponent, data: {title: 'Welcome'}, canActivate: [AuthGuard], pathMatch: 'full'},

  // DupliKit
  {
    path: DataToolsApps.DUPLIKIT, pathMatch: 'prefix', canActivate: [AuthGuard], data: {title: DataToolsAppsTitles.DUPLIKIT},
    children: [
      {path: '', pathMatch: 'prefix', redirectTo: 'dashboard'},
      {
        path: 'candidate-report',
        component: ReportComponent,
        data: {
          title: DataToolsAppsTitles.DUPLIKIT_CANDIDATE_REPORT,
          entity: 'candidate'
        }
      }, {
        path: 'contact-report',
        component: ReportComponent,
        data: {
          title: DataToolsAppsTitles.DUPLIKIT_CONTACT_REPORT,
          entity: 'contact'
        }
      }, {
        path: 'company-report',
        component: ReportComponent,
        data: {
          title: DataToolsAppsTitles.DUPLIKIT_COMPANY_REPORT,
          entity: 'company'
        }
      },
      {path: 'duplikit-options', component: DuplikitOptionsComponent, data: {title: DataToolsAppsTitles.DUPLIKIT_OPTIONS}},
      {path: 'dashboard', component: DashboardComponent, data: {title: DataToolsAppsTitles.DUPLIKIT_DASHBOARD}},
      {path: '**', redirectTo: 'dashboard'}
    ]
  },

  // DataCleaner
  {
    path: DataToolsApps.DATA_CLEANER,
    component: DataCleanerComponent,
    data: {title: DataToolsAppsTitles.DATA_CLEANER},
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },
  {
    path: `${DataToolsApps.DATA_CLEANER}/:searchId`,
    component: DataCleanerComponent,
    data: {title: DataToolsAppsTitles.DATA_CLEANER},
    canActivate: [AuthGuard]
  },

  // Configuration
  // {path: 'configuration', pathMatch: 'prefix', canActivate: [AuthGuard], children: [
  //         {path: '', pathMatch: 'prefix', redirectTo: 'configuration'},
  //         {path: 'configuration',         component: ConfigurationComponent,    data: {title: 'Configuration'}},
  //         {path: 'config',                component: ConfigHomeComponent,       data: {title: 'Configuration'}},
  //         {path: 'config-settings',       component: SettingsComponent,         data: {title: 'Configuration'}},
  //         {path: 'config-fieldmaps',      component: FieldMapsComponent,        data: {title: 'Configuration'}},
  //         {path: 'config-layouts',        component: LayoutsComponent,          data: {title: 'Configuration'}},
  //         {path: 'config-changesets',     component: ChangeSetsComponent,       data: {title: 'Configuration'}},
  //         {path: 'fieldmap-revision/:id', component: FieldMapRevisionComponent, data: {title: 'Configuration'}},
  //         {path: 'settings-revision/:id', component: SettingsRevisionComponent, data: {title: 'Configuration'}},
  //         {path: 'layout-revision/:id',   component: LayoutRevisionComponent,   data: {title: 'Configuration'}}
  //     ]
  // },

  // DataRules
  {
    path: DataToolsApps.DATARULES,
    component: DataRulesSwitchComponent,
    data: {title: DataToolsAppsTitles.DATARULES},
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },

  // DataTools
  {
    path: DataToolsApps.DATATOOLS_SETTINGS,
    component: DataToolsSettingsComponent,
    canActivate: [AuthGuard],
    data: {
      title: DataToolsAppsTitles.DATATOOLS_SETTINGS
    }
  },

  {
    path: DataToolsApps.ENRICHMENT_SETTINGS,
    component: EnrichmentSettingsComponent,
    canActivate: [AuthGuard],
    data: {
      title: DataToolsAppsTitles.ENRICHMENT_SETTINGS
    }
  },

  // User Management
  {
    path: DataToolsApps.USER_MANAGEMENT,
    component: UsersManagementComponent,
    canActivate: [AuthGuard],
    data: {
      title: DataToolsAppsTitles.USER_MANAGEMENT
    }
  },

  {
    path: DataToolsApps.HISTORY, pathMatch: 'prefix', canActivate: [AuthGuard], data: {title: DataToolsAppsTitles.HISTORY}, children: [
      {path: '', pathMatch: 'prefix', redirectTo: DataToolsApps.DATARULES},
      {
        path: DataToolsApps.DATARULES,
        canActivate: [AuthGuard],
        component: DataRulesHistoryComponent,
        data: {
          title: DataToolsAppsTitles.DATARULES
        }
      },
      {
        path: DataToolsApps.DUPLIKIT,
        canActivate: [AuthGuard],
        component: DuplikitHistoryComponent,
        data: {
          title: DataToolsAppsTitles.DUPLIKIT
        }
      },
      {
        path: DataToolsApps.ENRICHMENT_CREDIT_HISTORY,
        canActivate: [AuthGuard],
        component: EnrichmentCreditHistoryComponent,
        data: {
          title: DataToolsAppsTitles.ENRICHMENT_CREDIT_HISTORY
        }
      },
    ]
  },

  {
    path: 'token/:dataCenter',
    component: TokenComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule {
}
